export default "__VITE_ASSET__ByS1os82__"